import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import "jspdf-autotable";
import {
  allowOnlyNumbersandDecimal,
  multiGeneratePdf,
  mutliExportToExcel,
} from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import { Field, FormikProvider, Form, useFormik } from "formik";
import { FaRegSave } from "react-icons/fa";
import Select from "react-select";
import MasterService from "../../Services/MasterService";

export default function MonthlyDistrictPerform() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [search, setSearch] = useState("");

  const [tableData, setTableData] = useState([]);
  const [statusId, setStatusId] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [finyear, setFinyear] = useState([]);

  const [savedContribution, setSavedContribution] = useState(null);

  let username = localStorage.getItem("username");

  const formik = useFormik({
    initialValues: {
      year: "",
      level: "",
      contribution: "",
    },
    onSubmit: (values) => {},
  });

  useEffect(() => {
    MasterService.getfinTargetyears()
      .then((res) => {
        if (res?.data) {
          setFinyear(res.data);
        }
      })
      .catch(() => {
        showAlertMessage("Failed to load financial years", "error");
      });
  }, []);

  const getTableReport = (values) => {
    if (!values.year) {
      showAlertMessage("Financial Year is required", "error");
      return;
    }
    if (!values.level) {
      showAlertMessage("Level is required", "error");
      return;
    }
    if (!values.contribution) {
      showAlertMessage("Contribution is required", "error");
      return;
    }

    setSearch("");
    setShowTable(false);

    const params = {
      userId: username,
      year: values.year,
      level: values.level,
      contributionPer: Number(values.contribution),
      buttonType: "get",
    };

    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.DistrcitMonthlyReport(params)
      .then((res) => {
        if (Array.isArray(res.data?.SDESC) && res.data.SDESC.length > 0) {
          const data = res.data.SDESC;
          setTableData(data);

          const status =
            res.data?.contribution_status_id ??
            res.data?.SDESC?.[0]?.contribution_status_id ??
            null;

          setStatusId(status);

          const contributionValue =
            res.data?.SDESC?.[0]?.contributionper ?? null;

          setSavedContribution(contributionValue);

          setShowTable(true);
        } else {
          setTableData([]);
          setStatusId(null);
          setSavedContribution(null);
          setShowTable(false);
          showAlertMessage(res.data.SDESC);
        }
      })
      .catch(() => {
        showAlertMessage("Something went wrong", "error");
        setTableData([]);
        setStatusId(null);
        setSavedContribution(null);
        setShowTable(false);
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const SaveData = () => {
    const values = formik.values;

    if (!values.year || !values.level || !values.contribution) {
      showAlertMessage("All fields are required", "error");
      return;
    }

    const params = {
      userId: username,
      year: values.year,
      level: values.level,
      contributionPer: Number(values.contribution),
      buttonType: "save",
    };

    store.dispatch({ type: "SHOW_SPINNER" });

    KpiService.DistrcitMonthlyReport(params)
      .then((res) => {
        if (res.data && res.data.SCODE === "01") {
          showAlertMessage("Data Saved Successfully", "success");
          setStatusId(4);

          setTimeout(() => {
            getTableReport(values);
          }, 500);
        } else {
          showAlertMessage(res.data?.SDESC || "Save Failed", "error");
        }
      })
      .catch((err) => {
        showAlertMessage("Something went wrong while saving", "error");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const filteredData = Array.isArray(tableData)
    ? tableData.filter((item) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(search.toLowerCase()),
        ),
      )
    : [];

  const groupedData = Object.values(
    (Array.isArray(tableData) ? tableData : []).reduce((acc, item) => {
      const key = `${item.district_name}_${item.cs_indicator_type}`;

      if (!acc[key]) {
        acc[key] = {
          district_name: item.district_name,
          indicator_type: item.cs_indicator_type,
          indicator_count: 0,
        };
      }

      acc[key].indicator_count += 1;

      return acc;
    }, {}),
  );

  const summaryData = [];
  const districtMap = {};

  groupedData.forEach((item) => {
    summaryData.push({
      district_name: item.district_name,
      indicator_type: item.indicator_type,
      indicator_count: item.indicator_count,
    });

    if (!districtMap[item.district_name]) {
      districtMap[item.district_name] = 0;
    }

    districtMap[item.district_name] += item.indicator_count;
  });

  Object.keys(districtMap).forEach((district) => {
    summaryData.push({
      district_name: district,
      indicator_type: "TOTAL",
      indicator_count: districtMap[district],
    });
  });

  const groupedPivot = Object.values(
    filteredData.reduce((acc, item) => {
      const district = item.district_name;
      const mandal = item.mandal_name;
      const type = item.cs_indicator_type;

      if (!acc[district]) {
        acc[district] = {
          district_name: district,
          mandals: {},
        };
      }

      if (!acc[district].mandals[mandal]) {
        acc[district].mandals[mandal] = {
          mandal_name: mandal,
          Economic: 0,
          Social: 0,
          Governance: 0,
          TOTAL: 0,
        };
      }

      if (type === "Economic") acc[district].mandals[mandal].Economic += 1;
      if (type === "Social") acc[district].mandals[mandal].Social += 1;
      if (type === "Governance") acc[district].mandals[mandal].Governance += 1;

      acc[district].mandals[mandal].TOTAL =
        acc[district].mandals[mandal].Economic +
        acc[district].mandals[mandal].Social +
        acc[district].mandals[mandal].Governance;

      return acc;
    }, {}),
  );

  const grandTotal = groupedPivot.reduce(
    (acc, districtItem) => {
      Object.values(districtItem.mandals).forEach((m) => {
        acc.Economic += m.Economic;
        acc.Social += m.Social;
        acc.Governance += m.Governance;
        acc.TOTAL += m.TOTAL;
      });
      return acc;
    },
    { Economic: 0, Social: 0, Governance: 0, TOTAL: 0 },
  );

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "97%" }}>
        {" "}
        <div className="sa-title">
          {" "}
          <h2>
            {" "}
            Monthly District Performance<span> Rating Framework</span>{" "}
          </h2>{" "}
        </div>{" "}
      </Container>
      <Container
        fluid
        style={{ width: "97%" }}
        className="outer-page-content-container"
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container py-2 px-4 mb-3">
              <Row className="align-items-end g-3">
                <Col xs={12} sm={6} md={3} lg={3}>
                  <label className="fw-bold d-block">
                    Financial Year <span className="text-danger">*</span>
                  </label>

                  <Select
                    name="year"
                    options={finyear.map((item) => ({
                      value: item.id,
                      label: item.value,
                    }))}
                    value={
                      finyear
                        .map((item) => ({
                          value: item.id,
                          label: item.value,
                        }))
                        .find((opt) => opt.value === formik.values.year) || null
                    }
                    onChange={(option) => {
                      const yearValue = option?.value || "";

                      formik.setFieldValue("year", yearValue);
                      setSearch("");
                      formik.setFieldValue("level", "");
                      formik.setFieldValue("contribution", "");
                      setTableData([]);
                      setStatusId(null);
                      setSavedContribution(null);
                    }}
                    placeholder="--Select Year--"
                    isClearable
                    className="w-100"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      control: (base) => ({
                        ...base,
                        height: "38px",
                        minHeight: "38px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        height: "38px",
                        padding: "0 8px",
                      }),
                      indicatorsContainer: (base) => ({
                        ...base,
                        height: "38px",
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Col>

                <Col xs={12} sm={6} md={3} lg={3}>
                  <label className="fw-bold d-block">
                    Level <span className="text-danger">*</span>
                  </label>

                  <Field
                    as="select"
                    name="level"
                    className="form-control"
                    style={{ height: "38px" }}
                    onChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("contribution", "");
                      setSearch("");
                      setTableData([]);
                      setStatusId(null);
                      setSavedContribution(null);
                    }}
                  >
                    <option value="">--Select--</option>
                    <option value="District">District</option>
                    <option value="Mandal">Mandal</option>
                  </Field>
                </Col>

                <Col xs={12} sm={6} md={3} lg={3}>
                  <label className="fw-bold d-block">
                    Contribution % <span className="text-danger">*</span>
                  </label>

                  <Field
                    type="text"
                    name="contribution"
                    className="form-control"
                    style={{ height: "38px" }}
                    placeholder="Enter Contribution"
                    autoComplete="off"
                    onKeyPress={allowOnlyNumbersandDecimal}
                    maxLength={3}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || !isNaN(value)) {
                        if (value === "" || parseFloat(value) <= 10) {
                          formik.handleChange(e);
                          setSearch("");
                          setTableData([]);
                          setStatusId(null);
                        }
                      }
                    }}
                  />
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  md={3}
                  lg={1}
                  className="d-flex align-items-end"
                >
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    style={{ height: "38px" }}
                    onClick={() => getTableReport(formik.values)}
                  >
                    Get Data
                  </button>
                </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>
        {showTable && (
          <>
            <Row>
              <Col
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
                xxl={3}
                className=" mb-3"
              >
                <div
                  style={{
                    display: "flex",
                    border: "1px solid #ddd",
                    alignItems: "center",
                    borderRadius: "20px",
                    transition: "all 0.3s ease-in-out",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "5px 10px",
                    width: "150px",
                    minWidth: "150px",
                  }}
                  id="search-container"
                >
                  <AiOutlineSearch
                    className="me-2"
                    style={{
                      fontSize: "1.2rem",
                      color: "#888",
                      visibility: "visible",
                    }}
                  />
                  <input
                    type="text"
                    placeholder={`records: ${tableData?.length ? tableData.length : 0} `}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onFocus={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)";
                      parent.style.border = "1px solid #353935";
                      parent.style.width = "100%";
                    }}
                    onBlur={(e) => {
                      const parent = e.currentTarget.parentElement;
                      parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                      parent.style.border = "1px solid #ddd";
                      parent.style.width = "150px";
                    }}
                    style={{
                      flex: "1",
                      border: "none",
                      outline: "none",
                      fontSize: "1rem",
                      color: "#333",
                      backgroundColor: "transparent",
                      transition: "color 0.3s ease",
                      minWidth: "0",
                    }}
                  />
                </div>
              </Col>
              <Col className="mb-2">
                <button
                  className="btn btn-danger btn-sm mx-2 pdf-btn"
                  onClick={() =>
                    multiGeneratePdf(
                      "report-section",
                      "monthlyDistrictPerformanceStatusReport",
                    )
                  }
                  style={{ float: "right", marginLeft: "3px" }}
                >
                  {" "}
                  PDF <MdOutlinePictureAsPdf />{" "}
                </button>{" "}
                <button
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{
                    float: "right",
                    color: "#ffffff",
                    marginLeft: "3px",
                  }}
                  onClick={() =>
                    mutliExportToExcel(
                      "report-section",
                      "monthlyDistrictPerformanceStatusReport",
                    )
                  }
                >
                  {" "}
                  Excel <AiFillFileExcel style={{ fontSize: "18px" }} />{" "}
                </button>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                backgroundColor: "#d4e3d8",
                padding: "6px 10px",
              }}
              className="rounded-1 border"
            >
              <div style={{ minWidth: "200px" }}>
                {statusId === "4" && savedContribution !== null && (
                  <span style={{ color: "#e40b28", fontWeight: "600" }}>
                    Contribution saved with : {savedContribution}%
                  </span>
                )}
              </div>

              <div style={{ flex: 1, textAlign: "center" }}>
                <span className="style">
                  Monthly District Performance Rating Framework
                </span>
              </div>

              <div style={{ minWidth: "200px" }}></div>
            </div>

            <div className="my-2">
              <div id="report-section">
                <Row>
                  <Col lg={7}>
                    <div className="table-container">
                      <Table
                        bordered
                        id="my-table"
                        className="table table-bordered custom-table table-responsive sticky-table w-100"
                      >
                        <thead className="table-dark text-center">
                          <tr>
                            <th>S.No</th>
                            <th>District Name</th>
                            {formik.values.level === "Mandal" && (
                              <th>Mandal Name</th>
                            )}

                            <th>Indicator Name</th>
                            <th>Indicator Type</th>
                            <th>Criterion Name</th>
                            <th>Level</th>
                            <th>Targets</th>
                            <th>Contribution %</th>
                          </tr>
                        </thead>

                        <tbody className="text-center">
                          {filteredData?.length > 0 ? (
                            filteredData?.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.district_name}</td>
                                {formik.values.level === "Mandal" && (
                                  <td>{item.mandal_name}</td>
                                )}
                                <td>{item.cs_indicator_name}</td>
                                <td>{item.cs_indicator_type}</td>
                                <td>{item.criterion_name}</td>
                                <td>{item.level}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.targets}
                                </td>
                                <td className="text-end">
                                  {item.contribution_percentage}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" style={{ textAlign: "center" }}>
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>

                  <Col lg={5}>
                    <div className="table-container">
                      <Table
                        bordered
                        className="table table-bordered custom-table table-responsive sticky-table w-100"
                      >
                        <thead className="table-dark text-center">
                          <tr>
                            <th rowSpan="2">District Name</th>
                            {formik.values.level === "Mandal" && (
                              <th rowSpan="2">Mandal Name</th>
                            )}
                            <th colSpan="3">Criterion Name</th>
                            <th rowSpan="2">TOTAL</th>
                          </tr>
                          <tr>
                            <th>Economic</th>
                            <th>Social</th>
                            <th>Governance</th>
                          </tr>
                        </thead>

                        <tbody className="text-center">
                          {groupedPivot.length > 0 ? (
                            <>
                              {groupedPivot.map((districtItem, dIndex) => {
                                const mandals = Object.values(
                                  districtItem.mandals,
                                );

                                return mandals.map((mandalItem, mIndex) => (
                                  <tr
                                    key={`${dIndex}-${mIndex}`}
                                    className={
                                      dIndex % 2 === 0
                                        ? "district-even"
                                        : "district-odd"
                                    }
                                    style={{
                                      borderTop:
                                        mIndex === 0
                                          ? "2px solid #000"
                                          : "none",
                                    }}
                                  >
                                    {mIndex === 0 && (
                                      <td
                                        rowSpan={mandals.length}
                                        className="district-name"
                                        ref={(el) => {
                                          if (el) {
                                            el.style.setProperty(
                                              "vertical-align",
                                              "top",
                                              "important",
                                            );
                                          }
                                        }}
                                      >
                                        {districtItem.district_name}
                                      </td>
                                    )}

                                    {formik.values.level === "Mandal" && (
                                      <td>{mandalItem.mandal_name}</td>
                                    )}

                                    <td className="text-end">
                                      {mandalItem.Economic}
                                    </td>
                                    <td className="text-end">
                                      {mandalItem.Social}
                                    </td>
                                    <td className="text-end">
                                      {mandalItem.Governance}
                                    </td>

                                    <td className="total-cell text-end">
                                      {mandalItem.TOTAL}
                                    </td>
                                  </tr>
                                ));
                              })}

                              <tr className="grand-total-rowg">
                                <td
                                  colSpan={
                                    formik.values.level === "Mandal" ? 2 : 1
                                  }
                                  className="text-center"
                                >
                                  <span>GRAND TOTAL</span>
                                </td>

                                <td className="text-end ">
                                  {grandTotal.Economic}
                                </td>
                                <td className="text-end ">
                                  {grandTotal.Social}
                                </td>
                                <td className="text-end ">
                                  {grandTotal.Governance}
                                </td>

                                <td className=" text-end">
                                  {grandTotal.TOTAL}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan="6" style={{ textAlign: "center" }}>
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                  {tableData?.length > 0 && statusId !== "4" && (
                    <div className="bottom-buttons d-flex justify-content-center mt-4 mb-5">
                      <button
                        size="sm"
                        className="save-btn me-4"
                        onClick={SaveData}
                      >
                        Save <FaRegSave className="ms-1 s-icon" />
                      </button>
                    </div>
                  )}
                </Row>
              </div>
            </div>
          </>
        )}
      </Container>
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
    </>
  );
}
